<template lang="pug">
    div(ref="newsContainer" class="news-list")
        template(v-for="(news, id) in newsLoadedAtTheMoment")
            div(@focus="handleFocus()" @focusout="handleFocusOut()"
                class="news-list-item stn-sdw"
                :class="(expanderId !== id) ? 'minimize-block' : ''"
                :style="(expanderId === id) ? `height:${getElementsHeight(id)}px; transition:height .3s;` : ''"
                :tabindex="id")
                div(:id="`element${id}`")
                    div(class="news-item-info" style="")
                        template(v-for="n in news.tickers" style="display: flex")
                            Ticker(:stockId="isNaN(stock_id) ? n.stock_id : stock_id")
                        span(v-for="(tag, index) in news.tags.filter((t) => t === 'TA:pressrelease')" class="local-tag-item") {{ getTagName(tag) }}
                        div(v-if="dateAndTimeFormatting(news).date !== null") {{ dateAndTimeFormatting(news).date }}
                        div(v-if="dateAndTimeFormatting(news).time !== null") {{ dateAndTimeFormatting(news).time }}
                        div(class="toggle-item-btn" style="")
                            v-icon(v-if="expanderId !== id" @click="expanderToggle(id)") mdi-chevron-down
                            v-icon(v-else @click="expanderToggle(id)" ref="chevronUpElement") mdi-chevron-up
                    div(class="news-item-content")
                        div(class="item-title") {{ news.title }}

                        div(v-if="news.type !== 2" style="display: table")
                            div(class="item-text" v-html="news.newstext")
                        div(v-else style="display: table")
                            CompanyLogo(:company_id="news.company_id")
                            div(class="item-text narrow" v-html="news.newstext")

                        div(class="tags-list")
                            h6() {{ $t('topics') }}
                            span(v-for="(tag, index) in news.tags.filter((t) => t !== 'TA:pressrelease')" class="tag-item")
                                span() {{ getTagName(tag) }}
</template>

<script>
import Ticker from "../../components/Ticker.vue";
import CompanyLogo from "./CompanyLogo.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
    name: 'NewsInformation',
    components: {
        Ticker,
        CompanyLogo
    },
    props: {
        viewMode: {
            type: String,
            default: null
        },
        company_id: {
            type: Number,
            default: null
        },
        // stock_id: {
        //     type: Number,
        //     default: null
        // }
    },
    data() {
        return {
            expanderId: null,
            newsLoadedAtTheMoment: [],
            localNewsItems: [],
            localNewsMaxDate: null,
            scrollCheck: 'no',
            checkDoFocused: true,
            onlyOneTimeCheck: 1
        };
    },
    async mounted() {
        if(this.company_id !== null) {
            await this.loadCompanyNews(this.company_id);
        }

        await this.loadTheNews();

        this.generateTableFormating();
    },
    watch: {
        async newsItems() {
            if(this.scrollCheck !== 'scrolled to bottom') {
                console.log('not scrolled');
                this.newsLoadedAtTheMoment = [];

                this.localNewsItems = this.newsItems;
            } else {
                if(this.viewMode === 'all') {
                    this.localNewsItems = this.localNewsItems.concat(this.newsItems);
                }
            }

            if(this.company_id === null) {
                await this.loadTheNews();
            }

            this.generateTableFormating();
        },
        getNewsDates() {
            this.localNewsMaxDate = this.getNewsDates;
        }
    },
    computed: {
        ...mapGetters([
            "getCompanyNews",
            "getNews",
            "getNewsWatched",
            "getNewsMaxMinDate"
        ]),
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        },
        stock_id() {
            return parseInt(this.$route.params.stock_id);
        },
        newsItems() {
            let news;

            if (this.viewMode==='all') {
                news = this.getNews;
            } else if  (this.viewMode==='watched') {
                news = this.getNewsWatched;
            } else if (this.company_id !== null && this.stock_id !== null) {
                news = this.getCompanyNews;
            }

            return news;
        },
        getNewsContainer() {
            return this.$refs.newsContainer;
        },
        getNewsMaxDate() {
            return _.maxBy(this.getNewsMaxMinDate, (o) => o.date).date;
        },
        getNewsMinDate() {
            return _.minBy(this.getNewsMaxMinDate, (o) => o.date).date;
        },
        getNewsDates() {
            return Object.keys(_.groupBy(this.getNewsMaxMinDate, (o) => o.date));
        }
    },
    methods: {
        ...mapActions(["loadCompanyNews", "loadNews50", "loadNewsWatched"]),
        handleFocusOut() {
            setTimeout(() => {
                if(this.checkDoFocused) {
                    try {
                        this.$refs.chevronUpElement[0].$el.click();
                    } catch (error) {
                        console.log(error.message);
                    }
                }
            }, 50);
        },
        handleFocus() {
            this.checkDoFocused = false;

            setTimeout(() => {
                this.checkDoFocused = true;
            }, 100);
        },
        async loadTheNews() {
            try {
                if(this.localNewsItems.length > 20 && this.newsLoadedAtTheMoment.length === 0) {
                    this.newsLoadedAtTheMoment = this.localNewsItems.slice(0, 20);
                } else if(this.localNewsItems.length > this.newsLoadedAtTheMoment.length && (this.localNewsItems.length - this.newsLoadedAtTheMoment.length) > 20) {
                    const subArray = this.localNewsItems.slice(this.newsLoadedAtTheMoment.length, this.newsLoadedAtTheMoment.length + 20);
                    this.newsLoadedAtTheMoment = _.concat(this.newsLoadedAtTheMoment, subArray);
                } else if(this.localNewsItems.length - this.newsLoadedAtTheMoment.length <= 20 && this.localNewsItems.length > this.newsLoadedAtTheMoment.length) {
                    const subArray = this.localNewsItems.slice(this.newsLoadedAtTheMoment.length, this.localNewsItems.length);
                    this.newsLoadedAtTheMoment = _.concat(this.newsLoadedAtTheMoment, subArray);

                    if(this.localNewsMaxDate !== null) {
                        this.localNewsMaxDate.shift();

                        const filterFlag = this.$parent.filterFlag;
                        const tags = (this.$parent.$refs.wordCloudNewComponent.selectedTags.length > 0) ? this.$parent.$refs.wordCloudNewComponent.selectedTags.map((t) => {
                            t = t.substring(4, t.length);
                            return t;
                        }) : [''];

                        if(this.localNewsMaxDate.length > 0) {
                            const tagsObject = {
                                user_id: this.user_id,
                                tags: tags,
                                date: this.localNewsMaxDate[0],
                                filterFlag: filterFlag
                            };

                            this.$parent.scrollBackLittle();

                            if(this.viewMode === "all") {
                                await this.loadNews50(tagsObject);
                            } else {
                                await this.loadNewsWatched(tagsObject);
                            }
                        }
                    }
                }

                this.generateTableFormating();
            } catch (error) {
                console.log(error.message);
            }
        },
        getElementsHeight(id) {
            return document.getElementById(`element${id}`).offsetHeight;
        },
        expanderToggle(id) {
            if(this.onlyOneTimeCheck < 2) {
                if(this.expanderId !== id) {
                    this.expanderId = id;
                } else if(this.expanderId === id) {
                    this.expanderId = null;
                }
            }

            this.onlyOneTimeCheck += 1;

            setTimeout(() => {
                this.onlyOneTimeCheck = 1;
            }, 100);
        },
        getTagName(tag) {
            let tagName = '';
            const checkIfStartWithFWN = tag.substring(0, 4);
            const checkIfStartWithTA = tag.substring(0, 3);

            tagName = `tag_${tag}`;

            if(checkIfStartWithFWN === 'FWN:') {
                tagName = `tag_fwn_${tag.substring(4, tag.length)}`;
            } else if(checkIfStartWithTA === 'TA:') {
                tagName = `tag_ta_${tag.substring(3, tag.length)}`;
            }

            return this.$t(`${tagName}`);
        },
        generateTableFormating() {
            const myInterval = setInterval(() => {
                const tds = this.getNewsContainer.querySelectorAll('td');

                if(tds !== null) {
                    for(const td of tds) {
                        const checkNaN = parseInt(td.innerText.replace('-', '').replace('−', '').replace('%', ''));

                        if(!Number.isNaN(checkNaN)) {
                            td.classList.add('align-right');
                        }

                        if(td.innerText.substring(0, 1) === '-' || td.innerText.substring(0, 1) === '−') {
                            td.classList.add('red-text');
                        }
                    }

                    clearInterval(myInterval);
                }
            }, 50);
        },
        dateAndTimeFormatting(news) {
            const dateToday = moment().format('YYYY-MM-DD');
            const dateInserted = moment(news.date).format('YYYY-MM-DD');
            const daysDiff = moment(dateToday).diff(moment(dateInserted), 'days');
            const timeInserted = moment(`${dateInserted} ${news.time}`).format('hh:mm');

            const formattedDateObject = {};

            if(daysDiff === 0) {
                formattedDateObject.date = null;
                formattedDateObject.time = (timeInserted !== 'Invalid date') ? timeInserted : null;
            } else if(daysDiff === 1) {
                formattedDateObject.date = this.$t('yesterday_first_capital');
                formattedDateObject.time = null;
            } else if(daysDiff >= 2) {
                formattedDateObject.date = dateInserted;
                formattedDateObject.time = null;
            }

            return formattedDateObject;
        }
    }
}
</script>

<style scoped>
/*@import url('https://fonts.googleapis.com/css?family=Montserrat');*/

.news-list {
    padding: 0 0 0 12px;
}

.company-news .news-list {
    padding: 0 0 0 2px;
}

.news-list-item {
    background-color: #fff;
    border-radius: 6px;
    margin: 12px 0 16px 0;
    overflow: hidden;
    position:relative;
}

.news-list-item > div {
    align-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    position: relative;
}

.minimize-block {
    height: 100px;
    transition: height .3s;
}

.news-item-info {
    display: flex;
    flex-direction: row;
    padding: 12px;
}

.news-item-info span {
    font-weight: 500;
}

.news-item-info .main-ticker-container {
    margin-right: 8px;
}

.news-item-content {
    max-width: 600px;
}

.news-item-content .item-title {
    color: rgba(47, 60, 61, 1);
    font-size: 16px;
    font-weight: 500;
    padding-left: 12px;
    margin-bottom: 12px;
    line-height: 1.3;
}

.news-item-content .item-text {
    color: rgba(47, 60, 61, 1);
    font-size: 14px;
    font-weight: 300;
    opacity: 1;
    padding-left: 12px;
    transition: opacity .3s;
}

.item-text.narrow {
    float: left;
    width: 75%;
}

.minimize-block .item-text,
.minimize-block .company-logo-placeholder {
    opacity: 0;
    transition: opacity .3s;
}

.toggle-item-btn {
    border-radius: 4px;
    position:absolute;
    top:10px;
    right:12px;
    cursor:pointer;
    width:24px;
    height: 24px;
}

.toggle-item-btn:hover {
    background-color: rgba(244,244,244,1);
}

.tag-container {
    display: inline-block;
    border-radius: 5px;
    border: 1px solid #FFABAB !important;
}

.local-tag-item {
    display: inline-block;
    background-color: rgba(20,75,77,.7);
    border-radius: 50px;
    color: #fff;
    font-size: 10px;
    margin: 0 10px 6px 0;
    padding: 4px 4px 4px 8px;
    text-transform: uppercase;
    vertical-align: middle;
}

.tags-list .tag-item {
    background-color: rgba(20,75,77,.7);
    border: 0px solid rgba(0,0,0,1);
    border-radius: 100px;
    color: #fff;
    padding: 4px 6px;
}

.tags-list > h6 {
    display: inline-block;
    margin: 0 10px 0 0;
    text-transform: uppercase;
}

>>> tbody {
    font-family: monospace;
    background-color: #ffffff;
    border: 1px solid #999999 !important;
}

>>> tbody td {
    min-width: 120px;
    max-width: 400px;
    padding: 8px;
    border: 1px solid #999999 !important;
}

>>> tbody tr:first-child {
    font-weight: bold;
}

>>> tbody tr:first-child td:first-child {
    font-size: 16px;
}

>>> tbody tr td:first-child {
    padding-right: 10px;
}
</style>
